<template>
  <Drawer
    :open="open"
    @update:open="$emit('update:open', $event)"
    variant="modal"
    background="white"
    :showFooter="false"
  >
    <template #content>
      <DrawerClose class="flex flex-col p-4 md:px-5 md:py-6 gap-2">
        <p v-if="item" class="font-medium text-base text-tertiary mb-2">
          {{ item.description }}
        </p>
        <ButtonList :items="actions" size="xl" @click="$event()" />
      </DrawerClose>
    </template>
  </Drawer>
  <Edit
    v-if="item && canUpdateChecklist"
    v-model:open="isEditDrawerOpen"
    :item="item"
    @update:description="$emit('update:description', $event)"
  />
  <Delete
    v-if="item && canDeleteChecklist"
    v-model:open="isConfirmDeleteDrawerOpen"
    :title="$t('components.task_details.checklist.delete.confirm.title')"
    :description="
      $t('components.task_details.checklist.delete.confirm.description', {
        name: item.name,
      })
    "
    @delete="$emit('delete:item', item)"
  />
</template>

<script setup>
import { ref, computed } from "vue";
import { ButtonList } from "@/SharedComponents/ButtonList";
import { Edit } from "@/SharedComponents/Checklist/Drawers";
import { Drawer, DrawerClose } from "@/SharedComponents/Drawer";
import { DeleteModal as Delete } from "@/SharedComponents/Modals";
import { useI18n } from "vue-i18n";

const emit = defineEmits([
  "update:open",
  "duplicate:item",
  "update:description",
  "delete:item",
]);

const props = defineProps({
  open: { type: Boolean, default: undefined },
  item: { type: Object, required: false },
  canUpdateChecklist: { type: Boolean, required: true },
  canDeleteChecklist: { type: Boolean, required: true },
});

const isEditDrawerOpen = ref(false);
const isConfirmDeleteDrawerOpen = ref(false);

const { t } = useI18n();

const actions = computed(() => {
  const actions = [];
  if (props.item?.checked) {
    return actions;
  }
  if (props.canUpdateChecklist) {
    actions.push(
      {
        id: "duplicate",
        icon: "copy",
        label: t("components.buttons.duplicate_checklist_item"),
        event: () => emit("duplicate:item", props.item),
      },
      {
        id: "edit",
        icon: "edit-pen",
        label: t("components.buttons.edit_checklist_item"),
        event: () => (isEditDrawerOpen.value = true),
      }
    );
  }
  if (props.canDeleteChecklist) {
    actions.push({
      id: "delete",
      icon: "delete",
      label: t("components.buttons.delete"),
      variant: "primary",
      type: "destructive",
      event: () => (isConfirmDeleteDrawerOpen.value = true),
    });
  }
  return actions;
});
</script>
